import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutHierarchyLevelLookup extends Layout {
    sourceHierarchyLevel: DataSource;
    tableHierarchyLevels: Table;
}
